"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
interface AuctionTimerProps {
  auctionFinishTime: string;
  textClassname?: string;
  showSeconds?: boolean;
}
const AuctionTimer = t0 => {
  const $ = _c(23);
  const {
    auctionFinishTime,
    textClassname,
    showSeconds: t1
  } = t0;
  const showSeconds = t1 === undefined ? false : t1;
  const timerRef = useRef(null);
  const rafRef = useRef(undefined);
  let t2;
  if ($[0] !== auctionFinishTime) {
    t2 = new Date(auctionFinishTime).getTime();
    $[0] = auctionFinishTime;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const targetTime = t2;
  let t3;
  if ($[2] !== showSeconds) {
    t3 = ms => {
      const totalSec = Math.floor(ms / 1000);
      if (showSeconds && totalSec < 300) {
        const minutes = Math.floor(totalSec / 60);
        const seconds = totalSec % 60;
        return `${minutes > 0 ? minutes + "m " : ""}${seconds}s`;
      }
      if (!showSeconds && totalSec < 300) {
        return `${totalSec}s`;
      }
      const days = Math.floor(totalSec / 86400);
      const hours = Math.floor(totalSec % 86400 / 3600);
      const minutes_0 = Math.floor(totalSec % 3600 / 60);
      if (showSeconds) {
        const seconds_0 = totalSec % 60;
        return `${days ? days + "d " : ""}${hours}h ${minutes_0}m ${seconds_0}s`;
      }
      return `${days ? days + "d " : ""}${hours}h ${minutes_0}m`;
    };
    $[2] = showSeconds;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const formatTimeLeft = t3;
  const initialTimeLeft = Math.max(0, targetTime - Date.now());
  const [timeLeftText, setTimeLeftText] = useState(initialTimeLeft > 0 ? formatTimeLeft(initialTimeLeft) : "Encerrado");
  const [colorClass, setColorClass] = useState(initialTimeLeft > 0 && initialTimeLeft < 86400000 ? "text-red-500" : "text-black");
  let t4;
  if ($[4] !== colorClass || $[5] !== formatTimeLeft || $[6] !== showSeconds || $[7] !== targetTime || $[8] !== timeLeftText) {
    t4 = () => {
      const updateTimer = () => {
        const now = Date.now();
        const diff = targetTime - now;
        const timeLeft = Math.max(0, diff);
        const newText = timeLeft > 0 ? formatTimeLeft(timeLeft) : "Encerrado";
        if (newText !== timeLeftText) {
          setTimeLeftText(newText);
        }
        const shouldBeRed = timeLeft > 0 && timeLeft < 86400000;
        if (shouldBeRed && colorClass !== "text-red-500" || !shouldBeRed && colorClass !== "text-black") {
          setColorClass(shouldBeRed ? "text-red-500" : "text-black");
        }
        if (timeLeft > 0) {
          if (timeLeft < 300000 || showSeconds) {
            rafRef.current = requestAnimationFrame(updateTimer);
          } else {
            setTimeout(() => {
              rafRef.current = requestAnimationFrame(updateTimer);
            }, 1000);
          }
        }
      };
      rafRef.current = requestAnimationFrame(updateTimer);
      return () => {
        if (rafRef.current) {
          cancelAnimationFrame(rafRef.current);
        }
      };
    };
    $[4] = colorClass;
    $[5] = formatTimeLeft;
    $[6] = showSeconds;
    $[7] = targetTime;
    $[8] = timeLeftText;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== auctionFinishTime || $[11] !== colorClass || $[12] !== showSeconds || $[13] !== timeLeftText) {
    t5 = [auctionFinishTime, colorClass, timeLeftText, showSeconds];
    $[10] = auctionFinishTime;
    $[11] = colorClass;
    $[12] = showSeconds;
    $[13] = timeLeftText;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "auto",
      display: "inline-block",
      textAlign: "right",
      textWrap: "nowrap"
    };
    t7 = cn("relative");
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  const t8 = `font-semibold text-md ${colorClass}`;
  let t9;
  if ($[17] !== t8 || $[18] !== textClassname) {
    t9 = cn(t8, textClassname);
    $[17] = t8;
    $[18] = textClassname;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9 || $[21] !== timeLeftText) {
    t10 = <div style={t6} className={t7} data-sentry-component="AuctionTimer" data-sentry-source-file="AuctionTimer.tsx"><span ref={timerRef} className={t9}>{timeLeftText}</span></div>;
    $[20] = t9;
    $[21] = timeLeftText;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default AuctionTimer;